import { createActionGroup, emptyProps, props } from "@ngrx/store";

// export const saveOauthState = createAction(
//   '[Auth] Save Oauth State',
//   props<{ oauthState: string }>()
// );
//
// export const saveOauthCodeVerifier = createAction(
//   '[Auth] Save Oauth Code Verifier',
//   props<{ oauthCodeVerifier: string }>()
// )
//
// export const saveOauthToken = createAction(
//   '[Auth] Save Oauth Token',
//   props<{ oauthToken: OauthToken }>()
// )


export const AuthOauthActions = createActionGroup({
  source: 'Auth',
  events: {
    'Save Oauth State': props<{ oauthStateValue: string }>(),
    'Save Oauth Code Verifier': props<{ oauthCodeVerifierValue: string }>(),
    'Clear Oauth Code Verifier': emptyProps(),
    'Save Oauth Token': props<{ oauthAccessTokenValue: string, oauthRefreshTokenValue: string }>(),
  },
});
